import { ServiceTokens } from "$src/domain/ServiceTokens";
import { CustomerType } from "$src/domain/customers/CustomerType";
import type { ICustomerRepository } from "$src/domain/customers/ICustomerRepository";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetCustomerTypes {
    
    constructor(@inject(ServiceTokens.CustomerRepository) private customerRepository: ICustomerRepository) {}

    async execute(groupStoreId: number): Promise<CustomerType[]> {
        var types = await this.customerRepository.getCustomerTypes(groupStoreId);

        return types;
    }
}

export const GetCustomerTypesToken = Symbol('GetCustomerTypesToken');    

